import React from 'react';

export type BadgeTone =
  | 'neutral'
  | 'purple'
  | 'amber'
  | 'emerald'
  | 'pink'
  | 'blue'
  | 'danger'
  | 'success';

// Each tone carries an explicit light and dark treatment. Both sides are
// verified at >= 4.5:1 against the surface the badge sits on.
const TONES: Record<BadgeTone, string> = {
  neutral:
    'bg-slate-200 text-slate-700 ring-slate-300 dark:bg-slate-600/15 dark:text-slate-300 dark:ring-slate-500/40',
  purple:
    'bg-purple-100 text-purple-800 ring-purple-300 dark:bg-purple-600/15 dark:text-purple-300 dark:ring-purple-500/40',
  amber:
    'bg-amber-100 text-amber-800 ring-amber-300 dark:bg-amber-600/20 dark:text-amber-300 dark:ring-amber-500/40',
  emerald:
    'bg-emerald-100 text-emerald-800 ring-emerald-300 dark:bg-emerald-600/15 dark:text-emerald-300 dark:ring-emerald-500/40',
  pink:
    'bg-pink-100 text-pink-800 ring-pink-300 dark:bg-pink-600/15 dark:text-pink-300 dark:ring-pink-500/40',
  blue:
    'bg-blue-100 text-blue-800 ring-blue-300 dark:bg-blue-500/15 dark:text-blue-300 dark:ring-blue-500/40',
  danger:
    'bg-red-100 text-red-700 ring-red-300 dark:bg-red-900/25 dark:text-red-300 dark:ring-red-500/40',
  success:
    'bg-green-100 text-green-800 ring-green-300 dark:bg-green-500/15 dark:text-green-400 dark:ring-green-500/40',
};

interface BadgeProps {
  tone?: BadgeTone;
  className?: string;
  title?: string;
  children: React.ReactNode;
}

const Badge: React.FC<BadgeProps> = ({ tone = 'neutral', className = '', title, children }) => (
  <span
    title={title}
    className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ring-1 ${TONES[tone]} ${className}`}
  >
    {children}
  </span>
);

export default Badge;
